export default "__VITE_ASSET__Bfj2Ekmx__"